import ListAndDetailsSubLayout, {
  addHeaderKeyToCell,
  type ListViewRegularItem,
  type TableRow,
  type TableColumn,
  type TableCell,
} from '@layouts/ListAndDetailsSubLayout';

export type ResourceType = 'root' | 'activity' | 'templates' | 'attachments';

export type HookResponse = Pick<Parameters<typeof ListAndDetailsSubLayout>[0],
  | 'items'
  | 'itemsCount'
  | 'filters'
  | 'dateFilter'
  | 'setDateFilter'
  | 'pagination'
  | 'reloadListView'
  | 'selectedId'
  | 'isFetchingList'
  | 'ifNoItemsText'
  | 'getDetailPagePath'
  | 'onSearch'
  | 'tableView'
  | 'openTableView'
>;

type ListItem = HookResponse['items'][number];

export type {
  ListViewRegularItem,
  TableRow,
  TableCell,
  TableColumn,
  ListItem,
};
export { addHeaderKeyToCell };
